import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of} from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class LogTimeService {
  private headers: HttpHeaders;
  private commentCounter: { [key: number]: Observable<number> } = {};

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  }

  GetcommentById(id, context, selecteddate) {
    return this.http.get<any>('LogTime/GetJobcommentdataById?id=' + id + '&context=' + context + '&selecteddate=' + selecteddate);
  }

  GetAllCommentForContext(id, context, selecteddate) {
    return this.http.get<any>('LogTime/GetAllCommentForContext?id=' + id + '&context=' + context + '&selecteddate=' + selecteddate);
  }

  GetJobDetails(Id) {
    return this.http.get<any>('LogTime/GetJobDetailsbyCommentId?Id=' + Id);
  }

  PostTimeLogCommentDaily(data) {
    return this.http.post<any>('LogTime/PostTimeLogCommentDaily', data);
  }

  PostDailyLogTime(data) {
    return this.http.post<any>('LogTime/AddDailyLogTime', data);
  }

  UpdateDailyLogTime(data) {
    return this.http.post<any>('LogTime/UpdateDailyLogTime', data);
  }

  GetAllCommentForLogId(id) {
    return this.http.get<any>('LogTime/GetAllCommentForLogId?LogId=' + id);
  }

  getCommentCountByLogId(id: number): Observable<number> {
    if (id in this.commentCounter) {
    return this.commentCounter[id];
    }

    if (id > 0) {
    this.commentCounter[id] = this.GetAllCommentForLogId(id).pipe(
        map(response => response.length),
        catchError(() => of(0))
    );
    } else {
    this.commentCounter[id] = of(0);
    }
    return this.commentCounter[id];
  }

  PostTimeForWeek(captureTime) {
    return this.http.post<any>('LogTime/PostTimeForWeek', captureTime, { headers: this.headers });
  }

  BulkAddLogTime(listcaptureTime) {
    return this.http.post<any>('LogTime/BulkAddLogTime', listcaptureTime, { headers: this.headers });
  }

  PostAddLogTime(captureTime) {
    return this.http.post<any>('LogTime/PostAddLogTime', captureTime, { headers: this.headers });
  }

  PostTimeLogComment(_comment) {
    return this.http.post<any>('LogTime/PostTimeLogComment', _comment, { headers: this.headers });
  }

}
